/**
 * Cleovivra: collection toggle for product-list sections.
 *
 * The section renders both collections' cards into one grid, tagged
 * data-cleo-group="primary" / "alt". Flipping data-cleo-collection-state on the
 * section swaps which group is visible — no refetch, so the switch is instant.
 */

const TOGGLE = '[data-cleo-collection-toggle]';
const SECTION = '[data-cleo-collection-state]';

function bind(button) {
  const section = button.closest(SECTION);
  if (!section) return;

  button.addEventListener('click', () => {
    const next = section.dataset.cleoCollectionState === 'alt' ? 'primary' : 'alt';
    section.dataset.cleoCollectionState = next;
    button.setAttribute('aria-pressed', String(next === 'alt'));
  });
}

function init(root = document) {
  const scope = root instanceof Element && root.matches?.(TOGGLE) ? [root] : root.querySelectorAll(TOGGLE);
  for (const button of scope) {
    if (button.dataset.cleoBound) continue;
    button.dataset.cleoBound = '1';
    bind(button);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init(), { once: true });
} else {
  init();
}

/* The theme editor re-renders sections in place; bind the fresh markup. */
document.addEventListener('shopify:section:load', (event) => init(event.target));
